import { makeStyles, Grid, createStyles } from "@material-ui/core";
import { StoreProductRequest } from "../../../model/Store";

interface Props {
  label: string;
  data: StoreProductRequest;
  setData(state: StoreProductRequest): void;
  onChange: any;
}

export default function StoreForm({label, data, setData, onChange}: Props) {
  const classes = useStyle();

  const setProductName = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setData({...data, product_name: e.target.value})
  }
  const setProductUrl = (e: React.ChangeEvent<HTMLInputElement>) => {
    setData({...data, product_url: e.target.value})
  }
  const setProductRanking = (e: React.ChangeEvent<HTMLInputElement>) => {
    setData({...data, product_ranking: Number(e.target.value)})
  }


  return (
    <Grid className={classes.container}>
      <Grid className={classes.label}>
        <p>{label}</p>
      </Grid>
      <Grid className={classes.textarea}>
        <textarea placeholder='이름을 입력해주세요' onChange={setProductName} rows={4} />
      </Grid>
      <Grid className={classes.input}>
        <input type='number' placeholder='랭킹을 입력해주세요' onChange={setProductRanking} />
      </Grid>
      <Grid className={classes.input}>
        <input placeholder='URL를 입력해주세요' onChange={setProductUrl} />
      </Grid>
      <Grid className={classes.input}>
        <input type='file' placeholder='파일을 업로드해주세요' onChange={onChange} />
      </Grid>
    </Grid>
  )
}

const useStyle = makeStyles(() => 
  createStyles({
    container: {
      width: '100%'
    },
    label: {
      width: '85%',
      margin: 'auto',
      '& p': {
        fontSize: 14,
        color: '#666',
        margin: '5px 0',
      }
    },
    input: {
      width: '90%',
      margin: '3px auto',
      border: '1px solid #556586',
      borderRadius: 12,
      padding: '8px 12px',
      boxSizing: 'border-box',
      '& input': {
        border: 'none',
        outline: 'none',
        width: '100%',
        fontSize: 12,
      }
    },
    textarea: {
      width: '90%',
      margin: '3px auto',
      border: '1px solid #556586',
      borderRadius: 12,
      padding: '8px 12px',
      boxSizing: 'border-box',
      '& textarea': {
        border: 'none',
        outline: 'none',
        width: '100%',
        fontSize: 12,
        resize: 'none',
      }
    }
  })
)